import React from "react";
import style from "./index.module.scss";
import { Button, Col, Row, Tooltip } from "antd";
import classNames from "classnames";
import SourceInfo from "./Components/SourceInfo";
import { GetMeetingListItemData } from "../../service";
import { useHistory } from "react-router-dom";

interface Props {
    data: GetMeetingListItemData;
    reload: () => void;
}
export default function MeetingListItem({ data, reload }: Props) {
    const history = useHistory();

    return (
        <div className={classNames(style.root)}>
            <Row
                type="flex"
                align="middle"
                justify="space-between"
                style={{ height: "100%" }}>
                <Col sm={12} className={style.left} xs={24}>
                    <div className={style.titleRow}>
                        <h1 className={style.title}>
                            <Tooltip title={data.title}>
                                <span className={style.over}>{data.title}</span>
                            </Tooltip>
                        </h1>
                    </div>

                    <SourceInfo reload={reload} item={data} />
                </Col>
                <Col className={style.toolsRow}>
                    <div className={style.tools}>
                        <Button
                            type="link"
                            size="small"
                            onClick={() =>
                                history.push(`meeting/${data?.meetingId}`)
                            }
                            className={classNames(style.button, style.hidden)}>
                            查看详情
                        </Button>
                        <Button
                            type="link"
                            target="_blank"
                            size="small"
                            href={data.url}
                            className={classNames(style.button, style.hidden)}>
                            进入会议
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
